module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Promote your business with Landing pages.","description":"Quickly build a landing pages with a template, and start collecting leads.","action":"Create a landing page"}}')
  delete Component.options._Ctor
}
